// fieldType  1 = text, 2 = radio, 3 = select, 4 = multi select, 5 = date, 6 = count

import { height } from "@mui/system";
import { consumCertEngText, englisText } from "./engLangObject";
import { consumCertGerText, germanText } from "./gerLangObject";

// flex 1 = row, 2 = column

export const statusArray = [
  { id: 1, title: "Draft" },
  { id: 2, title: "Issued" },
  { id: 3, title: "Correction Pending" },
  { id: 4, title: "Issued Version 2" },
];

export function getStatusByIds(id) {
  return statusArray.find((status) => status.id === id) || null;
}

const paymentStatus = [
  {
    title: "Pending",
    id: 1,
  },
  {
    title: "Paid",
    id: 2,
  },
  {
    title: "Unpaid",
    id: 3,
  },
  {
    title: "No payment required",
    id: 4,
  },
];
const paymentStatusGerm = [
  {
    title: "Ausstehend",
    id: 1,
  },
  {
    title: "Bezahlt",
    id: 2,
  },
  {
    title: "Unbezahlt",
    id: 3,
  },
  {
    title: "Keine Zahlung erforderlich",
    id: 4,
  },
];
export function getPaymentStatus(id, language) {
  const currentLanguage = language == "de" ? paymentStatusGerm : paymentStatus;
  const data = currentLanguage.find((status) => status.id === id) || null;
  return data ? data.title : null;
}

/////////////////////////////////////////////////////////////////////////////////////
////////////////////////////
//////////////////////
//////////////

// fieldType  1 = text, 2 = radio, 3 = select, 4 = multi select, 5 = date, 6 = count

// flex 1 = row, 2 = column
export const formStep1 = [
  {
    title: consumCertEngText.occasion,
    id: 1,
    select: false,
    name: "occasion_id",
    type: "text",
    required: true,
    fieldType: 3,
    popData: [
      {
        heading: consumCertEngText.Occasion_head,
        para1: consumCertEngText.Occasion_desc,
      },
    ],
  },
  {
    title: consumCertEngText.postal_code,
    id: 2,
    select: false,
    name: "postal_code",
    type: "number",
    required: false,
    fieldType: 1,
  },
  {
    title: consumCertEngText.building_type,
    id: 3,
    select: false,
    name: "building_type_id",
    type: "text",
    required: true,
    fieldType: 3,
    popData: [
      {
        heading: consumCertEngText.build_head,
        para1: consumCertEngText.build_desc,
      },
    ],
  },
  {
    title: consumCertEngText.year_of_construction,
    id: 4,
    select: false,
    name: "construction_year",
    type: "number",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: consumCertEngText?.year_of_construction,
        para1: consumCertEngText?.year_of_construction_paragraph,
      },
    ],
  },
  {
    title: consumCertEngText.number_of_apartments,
    id: 5,
    select: false,
    name: "number_of_apartments",
    type: "text",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: consumCertEngText.num_aprt,
        para1: consumCertEngText.num_aprtdesc,
      },
    ],
  },
  {
    title: consumCertEngText.eMail,
    id: 6,
    select: false,
    name: "email",
    type: "email",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: consumCertEngText.email,
        para1: consumCertEngText.e_para_1,
        para2: consumCertEngText.e_para_2,
      },
    ],
  },
  {
    title: consumCertEngText.number_of_floors,
    id: 8,
    select: false,
    name: "floors",
    type: "text",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: consumCertEngText.num_floor,
        para1: consumCertEngText.num_floor_desc,
      },
    ],
  },
  {
    title: consumCertEngText.floor_to_ceiling_height,
    id: 9,
    select: false,
    name: "floor_to_ceiling_height",
    type: "text",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: consumCertEngText.floor_ceiling,
        para1: consumCertEngText.floor_ceiling_desc,
      },
    ],
  },

  {
    title: consumCertEngText.is_there_heated_basement,
    choice: [
      {
        title: consumCertEngText.yes,
        value: true,
        id: 71,
      },
      {
        title: consumCertEngText.no,
        value: false,
        id: 72,
      },
    ],
    id: 7,
    name: "is_there_heated_basement",
    fieldType: 2,
    flex: 1,
    required: true,
  },
];
export const formStep1German = [
  {
    title: consumCertGerText.occasion,
    id: 1,
    select: false,
    name: "occasion_id",
    type: "text",
    required: true,
    fieldType: 3,
    popData: [
      {
        heading: consumCertGerText.Occasion_head,
        para1: consumCertGerText.Occasion_desc,
      },
    ],
  },
  {
    title: consumCertGerText.postal_code,
    id: 2,
    select: false,
    name: "postal_code",
    type: "number",
    required: false,
    fieldType: 1,
  },
  {
    title: consumCertGerText.building_type,
    id: 3,
    select: false,
    name: "building_type_id",
    type: "text",
    required: true,
    fieldType: 3,
    popData: [
      {
        heading: consumCertGerText.build_head,
        para1: consumCertGerText.build_desc,
      },
    ],
  },
  {
    title: consumCertGerText.year_of_construction,
    id: 4,
    select: false,
    name: "construction_year",
    type: "number",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: consumCertGerText?.year_of_construction,
        para1: consumCertGerText?.year_of_construction_paragraph,
      },
    ],
  },
  {
    title: consumCertGerText.number_of_apartments,
    id: 5,
    select: false,
    name: "number_of_apartments",
    type: "number",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: consumCertGerText.num_aprt,
        para1: consumCertGerText.num_aprtdesc,
      },
    ],
  },
  {
    title: consumCertGerText.eMail,
    id: 6,
    select: false,
    name: "email",
    type: "email",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: consumCertGerText.eMail,
        para1: consumCertGerText.e_para_1,
        para2: consumCertGerText.e_para_2,
      },
    ],
  },
  {
    title: consumCertGerText.number_of_floors,
    id: 8,
    select: false,
    name: "floors",
    type: "number",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: consumCertGerText.num_floor,
        para1: consumCertGerText.num_floor_desc,
      },
    ],
  },
  {
    title: consumCertGerText.floor_to_ceiling_height,
    id: 9,
    select: false,
    name: "floor_to_ceiling_height",
    type: "text",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: consumCertGerText.floor_ceiling,
        para1: consumCertGerText.floor_ceiling_desc,
      },
    ],
  },
  {
    title: consumCertGerText.is_there_heated_basement,
    choice: [
      {
        title: consumCertGerText.yes,
        value: true,
        id: 71,
      },
      {
        title: consumCertGerText.no,
        value: false,
        id: 72,
      },
    ],
    id: 7,
    name: "is_there_heated_basement",
    fieldType: 2,
    flex: 1,
    required: true,
  },
];

export const formStep4 = [
  {
    title: "21 March 2019 - 20 February 2020",
    id: 1,
    select: false,
    name: "first",
    type: "text",
    required: true,
  },
  {
    title: "21 March 2020 - 20 February 2021",
    id: 2,
    select: false,
    name: "second",
    type: "number",
    required: true,
  },
  {
    title: "21 March 2021 - 20 February 2022",
    id: 3,
    select: false,
    name: "third",
    type: "text",
    required: true,
  },
];
export const formStep6 = [
  {
    title: "Street or House Number",
    id: 1,
    select: false,
    name: "house",
    type: "text",
    required: true,
  },
  {
    title: "Postcode",
    id: 2,
    select: false,
    name: "postCode",
    type: "number",
    required: true,
  },
  {
    title: "Location",
    id: 3,
    select: false,
    name: "location",
    type: "text",
    required: true,
  },
];

export const formAddress1 = [
  {
    title: "Phone Number",
    id: 1,
    select: false,
    name: "number",
    type: "text",
    required: true,
  },
  {
    title: "Forename",
    id: 2,
    select: false,
    name: "forename",
    type: "number",
    required: true,
  },
  {
    title: "Surname",
    id: 3,
    select: false,
    name: "surname",
    type: "text",
    required: true,
  },
  {
    title: "Street & House Number",
    id: 4,
    select: false,
    name: "street",
    type: "number",
    required: true,
  },
  {
    title: "Postcode",
    id: 5,
    select: false,
    name: "postcode",
    type: "number",
    required: true,
  },
  {
    title: "Location",
    id: 6,
    select: false,
    name: "location",
    type: "email",
    required: true,
  },
  {
    title: "Email",
    id: 6,
    select: false,
    name: "email",
    type: "email",
  },
];

export const steps = [
  {
    id: 1,
    step: englisText.step_1,
    info: englisText.building_info,
    required: true,
  },
  {
    id: 2,
    step: englisText.step_2,
    info: englisText.heating_info,
    required: true,
  },
  {
    id: 3,
    step: englisText.step_3,
    info: englisText.heat_water_info,
    required: true,
  },
  {
    id: 4,
    step: englisText.step_4,
    info: englisText.vacancy_info,
    required: true,
  },
  {
    id: 5,
    step: englisText.step_5,
    info: englisText.property_info,
    required: true,
  },
  {
    id: 6,
    step: englisText.step_6,
    info: englisText.property_address,
    required: true,
  },
  {
    id: 7,
    step: englisText.step_7,
    info: englisText.certificate,
    required: true,
  },
  {
    id: 8,
    step: englisText.step_8,
    info: englisText.billing_delivery_address,
    required: true,
  },
];

export const stepsGerman = [
  {
    id: 1,
    step: germanText.step_1,
    info: germanText.building_info,
    required: true,
  },
  {
    id: 2,
    step: germanText.step_2,
    info: germanText.heating_info,
    required: true,
  },
  {
    id: 3,
    step: germanText.step_3,
    info: germanText.heat_water_info,
    required: true,
  },
  {
    id: 4,
    step: germanText.step_4,
    info: germanText.vacancy_info,
    required: true,
  },
  {
    id: 5,
    step: germanText.step_5,
    info: germanText.property_info,
    required: true,
  },
  {
    id: 6,
    step: germanText.step_6,
    info: germanText.property_address,
    required: true,
  },
  {
    id: 7,
    step: germanText.step_7,
    info: germanText.certificate,
    required: true,
  },
  {
    id: 8,
    step: germanText.step_8,
    info: germanText.billing_delivery_address,
    required: true,
  },
];

export function ordinalSuffix(number) {
  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return number + "th";
  } else if (lastDigit === 1) {
    return number + "st";
  } else if (lastDigit === 2) {
    return number + "nd";
  } else if (lastDigit === 3) {
    return number + "rd";
  } else {
    return number + "th";
  }
}

export function arrayId(_arr = []) {
  const arrNew = _arr.map((item) => item.id);
  return arrNew;
}

export function objectId(obj = {}) {
  return obj.id;
}

export function onlyId(obj = {}) {
  let id = obj.hasOwnProperty("id") ? obj.id : null;
  return id;
}

// export function formatDate(timestamp) {
//   if (!timestamp) return;
//   const date = new Date(timestamp);

//   // Get day with ordinal suffix (st, nd, rd, th)
//   const day = date.getDate();
//   const dayWithSuffix =
//     day +
//     (day % 10 === 1 && day !== 11
//       ? "st"
//       : day % 10 === 2 && day !== 12
//       ? "nd"
//       : day % 10 === 3 && day !== 13
//       ? "rd"
//       : "th");

//   // Get month
//   const month = date.toLocaleString("default", { month: "long" });

//   // Get year
//   const year = date.getFullYear();

//   // Format hours and minutes
//   const hours = date.getHours() % 12 || 12; // Convert 24-hour format to 12-hour
//   const minutes = date.getMinutes().toString().padStart(2, "0");
//   const ampm = date.getHours() >= 12 ? "PM" : "AM";

//   return `${dayWithSuffix} ${month}, ${year} | ${hours}:${minutes} ${ampm}`;
// }
export function formatDate(timestamp) {

  if (!timestamp) return;

  const date = new Date(timestamp);

  // Adjust to German time (Europe/Berlin)

  const germanDate = new Date(date.toLocaleString("en-US", { timeZone: "Europe/Berlin" }));

  // Get day with ordinal suffix (st, nd, rd, th)

  const day = germanDate.getDate();

  const dayWithSuffix =

    day +

    (day % 10 === 1 && day !== 11

      ? "st"

      : day % 10 === 2 && day !== 12

        ? "nd"

        : day % 10 === 3 && day !== 13

          ? "rd"

          : "th");

  // Get month in German (localize to 'de-DE')

  const month = germanDate.toLocaleString("de-DE", { month: "long" });

  // Get year

  const year = germanDate.getFullYear();

  // Format hours and minutes (convert to 12-hour format)

  const hours = germanDate.getHours() % 12 || 12; // Convert 24-hour format to 12-hour

  const minutes = germanDate.getMinutes().toString().padStart(2, "0");

  const ampm = germanDate.getHours() >= 12 ? "PM" : "AM";

  return `${dayWithSuffix} ${month}, ${year} | ${hours}:${minutes} ${ampm}`;

}
export const conertDate = (timestamp) => {
  if (!timestamp) return;

  const date = new Date(timestamp);

  // Adjust to German time (Europe/Berlin)

  const germanDate = new Date(date.toLocaleString("en-US", { timeZone: "Europe/Berlin" }));

  // Get day with ordinal suffix (st, nd, rd, th)

  const day = germanDate.getDate();

  const dayWithSuffix = day
  // Get month in German (localize to 'de-DE')

  const month = germanDate.toLocaleString("de-DE", { month: "long" });

  // Get year

  const year = germanDate.getFullYear();


  return `${dayWithSuffix}-${month}-${year}`;

}

const certificateStatus = [
  { title: "Draft", id: 1 },
  { title: "Issued", id: 2 },
  { title: "Correction Pending", id: 3 },
  { title: "Issued Version 2", id: 4 },
];
const certificateStatusGerm = [
  { title: "Entwurf", id: 1 },
  { title: "Ausgestellt", id: 2 },
  { title: "Berichtigung anhängig", id: 3 },
  { title: "Ausgegebene Version 2", id: 4 },
];

export function getStatusById(id, language) {
  const currentLanguage =
    language === "de" ? certificateStatusGerm : certificateStatus;
  const data = currentLanguage?.find((status) => status.id === id) || null;
  return data ? data.title : null;
}

export function convertCommaToDot(inputString) {
  if (inputString === null || inputString === undefined) {
    return inputString; // Return the input as is if it's null or undefined
  }
  return inputString.toString().replace(/,/g, ".");
}

export function convertDotToComma(inputString) {
  if (inputString === null || inputString === undefined) {
    return inputString; // Return the input as is if it's null or undefined
  }
  return inputString.toString().replace(/\./g, ",");
}

export function toggleValueInArray(arr, value) {
  const newArray = [...arr]; // Create a copy of the array
  const index = newArray.indexOf(value);
  if (index === -1) {
    // Value doesn't exist, push it
    newArray.push(value);
  } else {
    // Value exists, remove it
    newArray.splice(index, 1);
  }
  return newArray; // Return the updated array
}

export const processArray = (array) => {
  const result = [];
  const idMap = new Map(); // Map to track the last object of each id

  // Traverse the array in reverse to keep the last occurrence of each id
  for (let i = array.length - 1; i >= 0; i--) {
    const obj = array[i];
    if (!idMap.has(obj.attached_wall_id)) {
      idMap.set(obj.attached_wall_id, obj);
    }
  }

  // Now that we've tracked the last occurrence of each id, we build the result
  for (let i = 0; i < array.length; i++) {
    if (idMap.has(array[i].attached_wall_id)) {
      result.push(idMap.get(array[i].attached_wall_id));
      idMap.delete(array[i].attached_wall_id); // Remove it from the map to ensure we only add the last occurrence
    }
  }

  return result;
};
export function processWindows(arr) {
  const wallIdCount = {};

  arr.forEach((item) => {
    wallIdCount[item.attached_wall_id] =
      (wallIdCount[item.attached_wall_id] || 0) + 1;
  });

  return arr.map((item) => {
    if (
      wallIdCount[item.attached_wall_id] > 1 &&
      (item.window_type_id === null || item.window_type_id === undefined)
    ) {
      const { window_type_id, ...rest } = item;
      return undefined;
    }
    return item;
  }).filter((item) => item !== undefined);
}